export const isInCheckout = (path: string) => {
  return path.startsWith("/checkout")
}
